import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { MODULE_LAYOUT_LABELS } from "entities/modules/constants";
import { GamesModuleLayout, ModuleLayout } from "entities/modules/types";
import CardWithPlaceholder from "entities/modules/widgets/CardWithPlaceholder";
import FiveVerticalCardsBlockPlaceholder from "entities/modules/widgets/FiveVerticalCardsBlockPlaceholder";
import FourHorizontalCardsBlockPlaceholder from "entities/modules/widgets/FourHorizontalCardsBlockPlaceholder";
import FourVerticalCardBlockPlaceholder from "entities/modules/widgets/FourVerticalCardBlockPlaceholder";
import ThreeBigHorizontalCardsBlockPlaceholder from "entities/modules/widgets/ThreeBigHorizontalCardsBlockPlaceholder";
import { useGeneralData } from "modules/brands/pages/ModulesContainer/components/SettingsModules/components/ModuleDetailsDrawer/stores/useGeneralData";
import { useEffect } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import TextField from "shared/components/Form/TextField";
import { COLOR_BLACK } from "shared/theme/colors";

const DEFAULT_ROWS = 1;
const MAX_ROWS = 2;

const GamesLayoutModuleSection = () => {
  const { rows, moduleLayout, studioFilterEnabled, setRows, setModuleLayout } =
    useGeneralData();

  const isTop10Layout = moduleLayout === GamesModuleLayout.Top10Games;
  const isBigHorizontalTiles =
    moduleLayout === GamesModuleLayout.BigHorizontalTiles;
  const isDisabledRows =
    isTop10Layout || isBigHorizontalTiles || studioFilterEnabled;
  const isDisabledTop10Card = studioFilterEnabled;
  const isDisabledBigHorizontalTiles = studioFilterEnabled;
  const isVerticalTiles = moduleLayout === GamesModuleLayout.VerticalTiles;
  const isHorizontalTiles = moduleLayout === GamesModuleLayout.HorizontalTiles;

  const handleLayoutSelect = (layout: ModuleLayout) => () => {
    setModuleLayout(layout);
  };

  useEffect(() => {
    if (isDisabledRows) {
      setRows(DEFAULT_ROWS);
    }
  }, [isDisabledRows, setRows]);

  return (
    <ContentSection title="MODULE CONFIGURATION">
      <Stack spacing="1rem">
        <Box
          display="grid"
          gridTemplateColumns="1fr 1fr 1fr"
          width="100%"
          gap="1rem"
        >
          <CardWithPlaceholder
            text={MODULE_LAYOUT_LABELS[GamesModuleLayout.VerticalTiles]}
            isActive={moduleLayout === GamesModuleLayout.VerticalTiles}
            placeholder={<FiveVerticalCardsBlockPlaceholder />}
            onSelect={handleLayoutSelect(GamesModuleLayout.VerticalTiles)}
          />
          <CardWithPlaceholder
            text={MODULE_LAYOUT_LABELS[GamesModuleLayout.HorizontalTiles]}
            isActive={moduleLayout === GamesModuleLayout.HorizontalTiles}
            placeholder={<FourHorizontalCardsBlockPlaceholder />}
            onSelect={handleLayoutSelect(GamesModuleLayout.HorizontalTiles)}
          />
          <CardWithPlaceholder
            text={MODULE_LAYOUT_LABELS[GamesModuleLayout.BigHorizontalTiles]}
            isActive={moduleLayout === GamesModuleLayout.BigHorizontalTiles}
            placeholder={<ThreeBigHorizontalCardsBlockPlaceholder />}
            onSelect={handleLayoutSelect(GamesModuleLayout.BigHorizontalTiles)}
            isDisabled={isDisabledBigHorizontalTiles}
          />
          <CardWithPlaceholder
            text={MODULE_LAYOUT_LABELS[GamesModuleLayout.Top10Games]}
            isActive={moduleLayout === GamesModuleLayout.Top10Games}
            placeholder={<FourVerticalCardBlockPlaceholder />}
            onSelect={handleLayoutSelect(GamesModuleLayout.Top10Games)}
            isDisabled={isDisabledTop10Card}
          />
        </Box>
        <TextField
          id="rows"
          label={
            isVerticalTiles
              ? "Rows (2 max for Vertical Tiles)"
              : isHorizontalTiles
                ? "Rows (2 max for Horizontal Tiles)"
                : "Rows"
          }
          labelColor={COLOR_BLACK}
          placeholder="Enter rows"
          inputProps={{ min: DEFAULT_ROWS, max: MAX_ROWS }}
          fullWidth
          disabled={isDisabledRows}
          type="number"
          value={rows}
          onChange={(e) => {
            const value = Number(e.target.value);
            if (value >= DEFAULT_ROWS && value <= MAX_ROWS) {
              setRows(value);
            } else if (value < DEFAULT_ROWS) {
              setRows(DEFAULT_ROWS);
            } else if (value > MAX_ROWS) {
              setRows(MAX_ROWS);
            }
          }}
        />
      </Stack>
    </ContentSection>
  );
};
export default GamesLayoutModuleSection;
